/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdditionalRateResponseV3,
  Booking,
  BookingCancellationResponse,
  BookingRequest,
  BookingStatuses,
  BookingStatusesRequest,
  CreateRateAlertRequest,
  DirectBookingCancelRequest,
  DirectBookingCancelResponse,
  FreeNightMatchRequest,
  FreeNightMatchResponse,
  HotelBookingResponse,
  HotelBookingUpdateRequest,
  HotelBookingUpdateResponse,
  HotelChatRequest,
  HotelComparisonResponse,
  HotelDetailsResponse,
  HotelDetailsResponseV3,
  HotelMetadata,
  HotelPropertyContentResponse,
  HotelReviewV2,
  HotelSearchRequest,
  HotelSearchResponse,
  HotelStatsRequest,
  HotelStatsResponse,
  LandingPageResponse,
  PaymentOption,
  PreBookRequest,
  PreBookResponse,
  PricePredictionRequest,
  PricePredictionResult,
  RateAlert,
  RateAlertCollection,
  RateRefundableRequestV2,
  RateRefundableResponseV2,
  RateValidationRequest,
  RateValidationRequestV2,
  RateValidationResponse,
  RateValidationResponseError,
  RateValidationResponseV2,
  ResearchSessionRequest,
  ResearchSessionResponse,
  ResearchSessionSamplePromptResponse,
  ResearchSessionsResponse,
  RoomAvailabilityRequest,
  RoomAvailabilityResponse,
  ScrapedContentSaveResponse,
  ScrapedPropertyContentBulkRequest,
  ScrapedRoomContentBulkRequest,
  SearchInteractionBatchRequest,
  SearchInteractionBatchResponse,
  SharedHotelBooking,
  SimilarHotelsResponse,
} from '../models/index';
import {
    AdditionalRateResponseV3FromJSON,
    AdditionalRateResponseV3ToJSON,
    BookingFromJSON,
    BookingToJSON,
    BookingCancellationResponseFromJSON,
    BookingCancellationResponseToJSON,
    BookingRequestFromJSON,
    BookingRequestToJSON,
    BookingStatusesFromJSON,
    BookingStatusesToJSON,
    BookingStatusesRequestFromJSON,
    BookingStatusesRequestToJSON,
    CreateRateAlertRequestFromJSON,
    CreateRateAlertRequestToJSON,
    DirectBookingCancelRequestFromJSON,
    DirectBookingCancelRequestToJSON,
    DirectBookingCancelResponseFromJSON,
    DirectBookingCancelResponseToJSON,
    FreeNightMatchRequestFromJSON,
    FreeNightMatchRequestToJSON,
    FreeNightMatchResponseFromJSON,
    FreeNightMatchResponseToJSON,
    HotelBookingResponseFromJSON,
    HotelBookingResponseToJSON,
    HotelBookingUpdateRequestFromJSON,
    HotelBookingUpdateRequestToJSON,
    HotelBookingUpdateResponseFromJSON,
    HotelBookingUpdateResponseToJSON,
    HotelChatRequestFromJSON,
    HotelChatRequestToJSON,
    HotelComparisonResponseFromJSON,
    HotelComparisonResponseToJSON,
    HotelDetailsResponseFromJSON,
    HotelDetailsResponseToJSON,
    HotelDetailsResponseV3FromJSON,
    HotelDetailsResponseV3ToJSON,
    HotelMetadataFromJSON,
    HotelMetadataToJSON,
    HotelPropertyContentResponseFromJSON,
    HotelPropertyContentResponseToJSON,
    HotelReviewV2FromJSON,
    HotelReviewV2ToJSON,
    HotelSearchRequestFromJSON,
    HotelSearchRequestToJSON,
    HotelSearchResponseFromJSON,
    HotelSearchResponseToJSON,
    HotelStatsRequestFromJSON,
    HotelStatsRequestToJSON,
    HotelStatsResponseFromJSON,
    HotelStatsResponseToJSON,
    LandingPageResponseFromJSON,
    LandingPageResponseToJSON,
    PaymentOptionFromJSON,
    PaymentOptionToJSON,
    PreBookRequestFromJSON,
    PreBookRequestToJSON,
    PreBookResponseFromJSON,
    PreBookResponseToJSON,
    PricePredictionRequestFromJSON,
    PricePredictionRequestToJSON,
    PricePredictionResultFromJSON,
    PricePredictionResultToJSON,
    RateAlertFromJSON,
    RateAlertToJSON,
    RateAlertCollectionFromJSON,
    RateAlertCollectionToJSON,
    RateRefundableRequestV2FromJSON,
    RateRefundableRequestV2ToJSON,
    RateRefundableResponseV2FromJSON,
    RateRefundableResponseV2ToJSON,
    RateValidationRequestFromJSON,
    RateValidationRequestToJSON,
    RateValidationRequestV2FromJSON,
    RateValidationRequestV2ToJSON,
    RateValidationResponseFromJSON,
    RateValidationResponseToJSON,
    RateValidationResponseErrorFromJSON,
    RateValidationResponseErrorToJSON,
    RateValidationResponseV2FromJSON,
    RateValidationResponseV2ToJSON,
    ResearchSessionRequestFromJSON,
    ResearchSessionRequestToJSON,
    ResearchSessionResponseFromJSON,
    ResearchSessionResponseToJSON,
    ResearchSessionSamplePromptResponseFromJSON,
    ResearchSessionSamplePromptResponseToJSON,
    ResearchSessionsResponseFromJSON,
    ResearchSessionsResponseToJSON,
    RoomAvailabilityRequestFromJSON,
    RoomAvailabilityRequestToJSON,
    RoomAvailabilityResponseFromJSON,
    RoomAvailabilityResponseToJSON,
    ScrapedContentSaveResponseFromJSON,
    ScrapedContentSaveResponseToJSON,
    ScrapedPropertyContentBulkRequestFromJSON,
    ScrapedPropertyContentBulkRequestToJSON,
    ScrapedRoomContentBulkRequestFromJSON,
    ScrapedRoomContentBulkRequestToJSON,
    SearchInteractionBatchRequestFromJSON,
    SearchInteractionBatchRequestToJSON,
    SearchInteractionBatchResponseFromJSON,
    SearchInteractionBatchResponseToJSON,
    SharedHotelBookingFromJSON,
    SharedHotelBookingToJSON,
    SimilarHotelsResponseFromJSON,
    SimilarHotelsResponseToJSON,
} from '../models/index';

export interface BookingBookingIdDeleteRequest {
    bookingId: string;
    test?: boolean;
    sendEmail?: boolean;
    rateUpdate?: boolean;
}

export interface BookingBookingIdGetRequest {
    bookingId: string;
}

export interface BookingBookingIdPutRequest {
    bookingId: string;
    hotelBookingUpdateRequest?: HotelBookingUpdateRequest;
}

export interface BookingCancellationGetRequest {
    bookingId?: number | null;
    hotelStayId?: string | null;
}

export interface BookingSharedShareTokenGetRequest {
    shareToken: string;
}

export interface BookingsStatusesPostRequest {
    bookingStatusesRequest?: BookingStatusesRequest;
}

export interface BrowserDirectCancelDeleteRequest {
    directBookingCancelRequest: DirectBookingCancelRequest;
}

export interface HotelChatPostRequest {
    hotelChatRequest: HotelChatRequest;
}

export interface HotelHotelIdDetailsGetRequest {
    hotelId: number;
    checkin: Date;
    checkout: Date;
    occupancy: string;
    userEnvironment: string;
}

export interface HotelHotelIdPaymentOptionsGetRequest {
    hotelId: string;
    availabilityToken: string;
}

export interface HotelHotelIdReviewsGetRequest {
    hotelId: string;
}

export interface HotelHotelIdSimilarGetRequest {
    hotelId: number;
    checkin: string;
    checkout: string;
    occupancy: string;
    test?: boolean;
    latitude?: number;
    longitude?: number;
}

export interface HotelRateValidationPostRequest {
    rateValidationRequest?: RateValidationRequest;
}

export interface HotelResearchSessionsPostRequest {
    researchSessionRequest?: ResearchSessionRequest;
}

export interface HotelResearchSessionsResearchSessionIdGetRequest {
    researchSessionId: string;
}

export interface HotelResearchSessionsResearchSessionIdPutRequest {
    researchSessionId: string;
    researchSessionRequest?: ResearchSessionRequest;
}

export interface HotelScrapedContentPropertyPostRequest {
    scrapedPropertyContentBulkRequest: ScrapedPropertyContentBulkRequest;
}

export interface HotelScrapedContentRoomPostRequest {
    scrapedRoomContentBulkRequest: ScrapedRoomContentBulkRequest;
}

export interface HotelStatsPostRequest {
    hotelStatsRequest?: HotelStatsRequest;
}

export interface HotelsRoomAvailabilityPostRequest {
    roomAvailabilityRequest: RoomAvailabilityRequest;
}

export interface PublicHotelHotelIdMetadataGetRequest {
    hotelId: number;
}

export interface RateAlertsAlertIdDeleteRequest {
    alertId: number;
}

export interface RateAlertsPostRequest {
    createRateAlertRequest: CreateRateAlertRequest;
}

export interface SearchHotelRoomTypesGetRequest {
    vervotechPropertyId?: number;
    placeId?: string;
}

export interface SearchHotelsPostRequest {
    hotelSearchRequest: HotelSearchRequest;
}

export interface SearchInteractionsPostRequest {
    searchInteractionBatchRequest: SearchInteractionBatchRequest;
}

export interface V2HotelFreeNightMatchPostRequest {
    freeNightMatchRequest: FreeNightMatchRequest;
}

export interface V2HotelHotelIdBookPostRequest {
    hotelId: string;
    bookingRequest?: BookingRequest;
}

export interface V2HotelHotelIdPreBookPostRequest {
    hotelId: string;
    preBookRequest: PreBookRequest;
}

export interface V2HotelHotelIdReviewsGetRequest {
    hotelId: string;
}

export interface V2HotelRateRefundablePostRequest {
    rateRefundableRequestV2?: RateRefundableRequestV2;
}

export interface V2HotelRateValidationPostRequest {
    rateValidationRequestV2?: RateValidationRequestV2;
}

export interface V3AdditionalRatesHotelIdGetRequest {
    hotelId: number;
    checkin: Date;
    checkout: Date;
    occupancy: string;
    checkinStr?: string;
    checkoutStr?: string;
    loyaltyAccountId?: string;
    rateSources?: Array<V3AdditionalRatesHotelIdGetRateSourcesEnum>;
    test?: boolean;
    scrapeRequestType?: V3AdditionalRatesHotelIdGetScrapeRequestTypeEnum;
    directRatesTimeout?: number;
    supportsGondolaCashDirectRates?: boolean;
}

export interface V3AdditionalRatesHotelIdStreamGetRequest {
    hotelId: number;
    checkin: Date;
    checkout: Date;
    occupancy: string;
    checkinStr?: string;
    checkoutStr?: string;
    loyaltyAccountId?: string;
    rateSources?: Array<V3AdditionalRatesHotelIdStreamGetRateSourcesEnum>;
    test?: boolean;
    scrapeRequestType?: V3AdditionalRatesHotelIdStreamGetScrapeRequestTypeEnum;
    directRatesTimeout?: number;
    supportsGondolaCashDirectRates?: boolean;
}

export interface V3HotelHotelIdContentGetRequest {
    hotelId: number;
}

export interface V3HotelHotelIdDetailsGetRequest {
    hotelId: number;
    checkin: Date;
    checkout: Date;
    occupancy: string;
    userEnvironment: string;
    checkinStr?: string;
    checkoutStr?: string;
    loyaltyAccountId?: string;
    rateSources?: Array<string>;
    test?: boolean;
    scrapeRequestType?: V3HotelHotelIdDetailsGetScrapeRequestTypeEnum;
    directRatesTimeout?: number;
}

export interface V3PricePredictPostRequest {
    pricePredictionRequest: PricePredictionRequest;
}

/**
 * 
 */
export class HotelsApi extends runtime.BaseAPI {

    /**
     * Cancel a booking
     */
    async bookingBookingIdDeleteRaw(requestParameters: BookingBookingIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Booking>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling bookingBookingIdDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        if (requestParameters['sendEmail'] != null) {
            queryParameters['send_email'] = requestParameters['sendEmail'];
        }

        if (requestParameters['rateUpdate'] != null) {
            queryParameters['rate_update'] = requestParameters['rateUpdate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/booking/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingFromJSON(jsonValue));
    }

    /**
     * Cancel a booking
     */
    async bookingBookingIdDelete(requestParameters: BookingBookingIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Booking> {
        const response = await this.bookingBookingIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a booking
     */
    async bookingBookingIdGetRaw(requestParameters: BookingBookingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Booking>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling bookingBookingIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/booking/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingFromJSON(jsonValue));
    }

    /**
     * Get a booking
     */
    async bookingBookingIdGet(requestParameters: BookingBookingIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Booking> {
        const response = await this.bookingBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update booking.
     */
    async bookingBookingIdPutRaw(requestParameters: BookingBookingIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelBookingUpdateResponse>> {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError(
                'bookingId',
                'Required parameter "bookingId" was null or undefined when calling bookingBookingIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/booking/{booking_id}`;
        urlPath = urlPath.replace(`{${"booking_id"}}`, encodeURIComponent(String(requestParameters['bookingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HotelBookingUpdateRequestToJSON(requestParameters['hotelBookingUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelBookingUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Update booking.
     */
    async bookingBookingIdPut(requestParameters: BookingBookingIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelBookingUpdateResponse> {
        const response = await this.bookingBookingIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get cancellation status by booking_id or hotel_stay_id. At least one must be provided.
     */
    async bookingCancellationGetRaw(requestParameters: BookingCancellationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookingCancellationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['bookingId'] != null) {
            queryParameters['booking_id'] = requestParameters['bookingId'];
        }

        if (requestParameters['hotelStayId'] != null) {
            queryParameters['hotel_stay_id'] = requestParameters['hotelStayId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/booking-cancellation`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingCancellationResponseFromJSON(jsonValue));
    }

    /**
     * Get cancellation status by booking_id or hotel_stay_id. At least one must be provided.
     */
    async bookingCancellationGet(requestParameters: BookingCancellationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookingCancellationResponse> {
        const response = await this.bookingCancellationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read a shared hotel itinerary using its unguessable share token.
     */
    async bookingSharedShareTokenGetRaw(requestParameters: BookingSharedShareTokenGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SharedHotelBooking>> {
        if (requestParameters['shareToken'] == null) {
            throw new runtime.RequiredError(
                'shareToken',
                'Required parameter "shareToken" was null or undefined when calling bookingSharedShareTokenGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/booking/shared/{share_token}`;
        urlPath = urlPath.replace(`{${"share_token"}}`, encodeURIComponent(String(requestParameters['shareToken'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedHotelBookingFromJSON(jsonValue));
    }

    /**
     * Read a shared hotel itinerary using its unguessable share token.
     */
    async bookingSharedShareTokenGet(requestParameters: BookingSharedShareTokenGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SharedHotelBooking> {
        const response = await this.bookingSharedShareTokenGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get booking statuses
     */
    async bookingsStatusesPostRaw(requestParameters: BookingsStatusesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BookingStatuses>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/bookings/statuses`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingStatusesRequestToJSON(requestParameters['bookingStatusesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BookingStatusesFromJSON(jsonValue));
    }

    /**
     * Get booking statuses
     */
    async bookingsStatusesPost(requestParameters: BookingsStatusesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BookingStatuses> {
        const response = await this.bookingsStatusesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a booking with browser
     */
    async browserDirectCancelDeleteRaw(requestParameters: BrowserDirectCancelDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DirectBookingCancelResponse>> {
        if (requestParameters['directBookingCancelRequest'] == null) {
            throw new runtime.RequiredError(
                'directBookingCancelRequest',
                'Required parameter "directBookingCancelRequest" was null or undefined when calling browserDirectCancelDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/browser/direct_cancel`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DirectBookingCancelRequestToJSON(requestParameters['directBookingCancelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DirectBookingCancelResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a booking with browser
     */
    async browserDirectCancelDelete(requestParameters: BrowserDirectCancelDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DirectBookingCancelResponse> {
        const response = await this.browserDirectCancelDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Session-based hotel chat. Loads hotels from the search session, optionally filters by hotel_ids or question keywords, and generates a personalized comparison or answers a freeform question.
     */
    async hotelChatPostRaw(requestParameters: HotelChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelComparisonResponse>> {
        if (requestParameters['hotelChatRequest'] == null) {
            throw new runtime.RequiredError(
                'hotelChatRequest',
                'Required parameter "hotelChatRequest" was null or undefined when calling hotelChatPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/chat`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HotelChatRequestToJSON(requestParameters['hotelChatRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelComparisonResponseFromJSON(jsonValue));
    }

    /**
     * Session-based hotel chat. Loads hotels from the search session, optionally filters by hotel_ids or question keywords, and generates a personalized comparison or answers a freeform question.
     */
    async hotelChatPost(requestParameters: HotelChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelComparisonResponse> {
        const response = await this.hotelChatPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details for a hotel.
     */
    async hotelHotelIdDetailsGetRaw(requestParameters: HotelHotelIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelDetailsResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling hotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['checkin'] == null) {
            throw new runtime.RequiredError(
                'checkin',
                'Required parameter "checkin" was null or undefined when calling hotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['checkout'] == null) {
            throw new runtime.RequiredError(
                'checkout',
                'Required parameter "checkout" was null or undefined when calling hotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['occupancy'] == null) {
            throw new runtime.RequiredError(
                'occupancy',
                'Required parameter "occupancy" was null or undefined when calling hotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['userEnvironment'] == null) {
            throw new runtime.RequiredError(
                'userEnvironment',
                'Required parameter "userEnvironment" was null or undefined when calling hotelHotelIdDetailsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkin'] != null) {
            queryParameters['checkin'] = (requestParameters['checkin'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkout'] != null) {
            queryParameters['checkout'] = (requestParameters['checkout'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['occupancy'] != null) {
            queryParameters['occupancy'] = requestParameters['occupancy'];
        }

        if (requestParameters['userEnvironment'] != null) {
            queryParameters['user_environment'] = requestParameters['userEnvironment'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/{hotel_id}/details`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Get details for a hotel.
     */
    async hotelHotelIdDetailsGet(requestParameters: HotelHotelIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelDetailsResponse> {
        const response = await this.hotelHotelIdDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get payment options for a property
     */
    async hotelHotelIdPaymentOptionsGetRaw(requestParameters: HotelHotelIdPaymentOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOption>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling hotelHotelIdPaymentOptionsGet().'
            );
        }

        if (requestParameters['availabilityToken'] == null) {
            throw new runtime.RequiredError(
                'availabilityToken',
                'Required parameter "availabilityToken" was null or undefined when calling hotelHotelIdPaymentOptionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['availabilityToken'] != null) {
            queryParameters['availability_token'] = requestParameters['availabilityToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/{hotel_id}/payment_options`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOptionFromJSON(jsonValue));
    }

    /**
     * Get payment options for a property
     */
    async hotelHotelIdPaymentOptionsGet(requestParameters: HotelHotelIdPaymentOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOption> {
        const response = await this.hotelHotelIdPaymentOptionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get reviews for a property
     */
    async hotelHotelIdReviewsGetRaw(requestParameters: HotelHotelIdReviewsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelReviewV2>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling hotelHotelIdReviewsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/{hotel_id}/reviews`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelReviewV2FromJSON(jsonValue));
    }

    /**
     * Get reviews for a property
     */
    async hotelHotelIdReviewsGet(requestParameters: HotelHotelIdReviewsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelReviewV2> {
        const response = await this.hotelHotelIdReviewsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get similar properties to a given hotel
     */
    async hotelHotelIdSimilarGetRaw(requestParameters: HotelHotelIdSimilarGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimilarHotelsResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling hotelHotelIdSimilarGet().'
            );
        }

        if (requestParameters['checkin'] == null) {
            throw new runtime.RequiredError(
                'checkin',
                'Required parameter "checkin" was null or undefined when calling hotelHotelIdSimilarGet().'
            );
        }

        if (requestParameters['checkout'] == null) {
            throw new runtime.RequiredError(
                'checkout',
                'Required parameter "checkout" was null or undefined when calling hotelHotelIdSimilarGet().'
            );
        }

        if (requestParameters['occupancy'] == null) {
            throw new runtime.RequiredError(
                'occupancy',
                'Required parameter "occupancy" was null or undefined when calling hotelHotelIdSimilarGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkin'] != null) {
            queryParameters['checkin'] = requestParameters['checkin'];
        }

        if (requestParameters['checkout'] != null) {
            queryParameters['checkout'] = requestParameters['checkout'];
        }

        if (requestParameters['occupancy'] != null) {
            queryParameters['occupancy'] = requestParameters['occupancy'];
        }

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        if (requestParameters['latitude'] != null) {
            queryParameters['latitude'] = requestParameters['latitude'];
        }

        if (requestParameters['longitude'] != null) {
            queryParameters['longitude'] = requestParameters['longitude'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/{hotel_id}/similar`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimilarHotelsResponseFromJSON(jsonValue));
    }

    /**
     * Get similar properties to a given hotel
     */
    async hotelHotelIdSimilarGet(requestParameters: HotelHotelIdSimilarGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimilarHotelsResponse> {
        const response = await this.hotelHotelIdSimilarGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get properties to display on the landing page
     */
    async hotelLandingPageGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LandingPageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/landing_page`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LandingPageResponseFromJSON(jsonValue));
    }

    /**
     * Get properties to display on the landing page
     */
    async hotelLandingPageGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LandingPageResponse> {
        const response = await this.hotelLandingPageGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Validate a rate before a booking is made with it
     */
    async hotelRateValidationPostRaw(requestParameters: HotelRateValidationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateValidationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/rate_validation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RateValidationRequestToJSON(requestParameters['rateValidationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateValidationResponseFromJSON(jsonValue));
    }

    /**
     * Validate a rate before a booking is made with it
     */
    async hotelRateValidationPost(requestParameters: HotelRateValidationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateValidationResponse> {
        const response = await this.hotelRateValidationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get research sessions
     */
    async hotelResearchSessionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResearchSessionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/research_sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResearchSessionsResponseFromJSON(jsonValue));
    }

    /**
     * Get research sessions
     */
    async hotelResearchSessionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResearchSessionsResponse> {
        const response = await this.hotelResearchSessionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a new research session
     */
    async hotelResearchSessionsPostRaw(requestParameters: HotelResearchSessionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResearchSessionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/research_sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResearchSessionRequestToJSON(requestParameters['researchSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResearchSessionResponseFromJSON(jsonValue));
    }

    /**
     * Create a new research session
     */
    async hotelResearchSessionsPost(requestParameters: HotelResearchSessionsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResearchSessionResponse> {
        const response = await this.hotelResearchSessionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get sample prompts
     */
    async hotelResearchSessionsPromptSamplesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResearchSessionSamplePromptResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/research_sessions/prompt_samples`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResearchSessionSamplePromptResponseFromJSON(jsonValue));
    }

    /**
     * Get sample prompts
     */
    async hotelResearchSessionsPromptSamplesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResearchSessionSamplePromptResponse> {
        const response = await this.hotelResearchSessionsPromptSamplesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a research session
     */
    async hotelResearchSessionsResearchSessionIdGetRaw(requestParameters: HotelResearchSessionsResearchSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResearchSessionResponse>> {
        if (requestParameters['researchSessionId'] == null) {
            throw new runtime.RequiredError(
                'researchSessionId',
                'Required parameter "researchSessionId" was null or undefined when calling hotelResearchSessionsResearchSessionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/research_sessions/{research_session_id}`;
        urlPath = urlPath.replace(`{${"research_session_id"}}`, encodeURIComponent(String(requestParameters['researchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResearchSessionResponseFromJSON(jsonValue));
    }

    /**
     * Get a research session
     */
    async hotelResearchSessionsResearchSessionIdGet(requestParameters: HotelResearchSessionsResearchSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResearchSessionResponse> {
        const response = await this.hotelResearchSessionsResearchSessionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a research session - add a new prompt
     */
    async hotelResearchSessionsResearchSessionIdPutRaw(requestParameters: HotelResearchSessionsResearchSessionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResearchSessionResponse>> {
        if (requestParameters['researchSessionId'] == null) {
            throw new runtime.RequiredError(
                'researchSessionId',
                'Required parameter "researchSessionId" was null or undefined when calling hotelResearchSessionsResearchSessionIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/research_sessions/{research_session_id}`;
        urlPath = urlPath.replace(`{${"research_session_id"}}`, encodeURIComponent(String(requestParameters['researchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResearchSessionRequestToJSON(requestParameters['researchSessionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResearchSessionResponseFromJSON(jsonValue));
    }

    /**
     * Update a research session - add a new prompt
     */
    async hotelResearchSessionsResearchSessionIdPut(requestParameters: HotelResearchSessionsResearchSessionIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResearchSessionResponse> {
        const response = await this.hotelResearchSessionsResearchSessionIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk upsert scraped property content. Internal endpoint used by api_point_scraper to push scraped hotel property media.
     */
    async hotelScrapedContentPropertyPostRaw(requestParameters: HotelScrapedContentPropertyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScrapedContentSaveResponse>> {
        if (requestParameters['scrapedPropertyContentBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'scrapedPropertyContentBulkRequest',
                'Required parameter "scrapedPropertyContentBulkRequest" was null or undefined when calling hotelScrapedContentPropertyPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/scraped-content/property`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScrapedPropertyContentBulkRequestToJSON(requestParameters['scrapedPropertyContentBulkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScrapedContentSaveResponseFromJSON(jsonValue));
    }

    /**
     * Bulk upsert scraped property content. Internal endpoint used by api_point_scraper to push scraped hotel property media.
     */
    async hotelScrapedContentPropertyPost(requestParameters: HotelScrapedContentPropertyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScrapedContentSaveResponse> {
        const response = await this.hotelScrapedContentPropertyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk upsert scraped room content. Internal endpoint used by api_point_scraper to push scraped hotel room media.
     */
    async hotelScrapedContentRoomPostRaw(requestParameters: HotelScrapedContentRoomPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScrapedContentSaveResponse>> {
        if (requestParameters['scrapedRoomContentBulkRequest'] == null) {
            throw new runtime.RequiredError(
                'scrapedRoomContentBulkRequest',
                'Required parameter "scrapedRoomContentBulkRequest" was null or undefined when calling hotelScrapedContentRoomPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/scraped-content/room`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScrapedRoomContentBulkRequestToJSON(requestParameters['scrapedRoomContentBulkRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScrapedContentSaveResponseFromJSON(jsonValue));
    }

    /**
     * Bulk upsert scraped room content. Internal endpoint used by api_point_scraper to push scraped hotel room media.
     */
    async hotelScrapedContentRoomPost(requestParameters: HotelScrapedContentRoomPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScrapedContentSaveResponse> {
        const response = await this.hotelScrapedContentRoomPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get stats for a hotel
     */
    async hotelStatsPostRaw(requestParameters: HotelStatsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelStatsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotel/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HotelStatsRequestToJSON(requestParameters['hotelStatsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get stats for a hotel
     */
    async hotelStatsPost(requestParameters: HotelStatsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelStatsResponse> {
        const response = await this.hotelStatsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Batch room availability check. Returns room tier availability from Travelport for the given properties and dates.
     */
    async hotelsRoomAvailabilityPostRaw(requestParameters: HotelsRoomAvailabilityPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomAvailabilityResponse>> {
        if (requestParameters['roomAvailabilityRequest'] == null) {
            throw new runtime.RequiredError(
                'roomAvailabilityRequest',
                'Required parameter "roomAvailabilityRequest" was null or undefined when calling hotelsRoomAvailabilityPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/hotels/room_availability`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoomAvailabilityRequestToJSON(requestParameters['roomAvailabilityRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomAvailabilityResponseFromJSON(jsonValue));
    }

    /**
     * Batch room availability check. Returns room tier availability from Travelport for the given properties and dates.
     */
    async hotelsRoomAvailabilityPost(requestParameters: HotelsRoomAvailabilityPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomAvailabilityResponse> {
        const response = await this.hotelsRoomAvailabilityPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public hotel metadata for link previews (og:title, description, image). No authentication required.
     */
    async publicHotelHotelIdMetadataGetRaw(requestParameters: PublicHotelHotelIdMetadataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelMetadata>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling publicHotelHotelIdMetadataGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/public/hotel/{hotel_id}/metadata`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelMetadataFromJSON(jsonValue));
    }

    /**
     * Public hotel metadata for link previews (og:title, description, image). No authentication required.
     */
    async publicHotelHotelIdMetadataGet(requestParameters: PublicHotelHotelIdMetadataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelMetadata> {
        const response = await this.publicHotelHotelIdMetadataGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a rate alert (soft delete)
     */
    async rateAlertsAlertIdDeleteRaw(requestParameters: RateAlertsAlertIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateAlert>> {
        if (requestParameters['alertId'] == null) {
            throw new runtime.RequiredError(
                'alertId',
                'Required parameter "alertId" was null or undefined when calling rateAlertsAlertIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/rate-alerts/{alert_id}`;
        urlPath = urlPath.replace(`{${"alert_id"}}`, encodeURIComponent(String(requestParameters['alertId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateAlertFromJSON(jsonValue));
    }

    /**
     * Delete a rate alert (soft delete)
     */
    async rateAlertsAlertIdDelete(requestParameters: RateAlertsAlertIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateAlert> {
        const response = await this.rateAlertsAlertIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all active rate alerts for the authenticated user
     */
    async rateAlertsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateAlertCollection>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/rate-alerts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateAlertCollectionFromJSON(jsonValue));
    }

    /**
     * Get all active rate alerts for the authenticated user
     */
    async rateAlertsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateAlertCollection> {
        const response = await this.rateAlertsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a new rate alert for a hotel
     */
    async rateAlertsPostRaw(requestParameters: RateAlertsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateAlert>> {
        if (requestParameters['createRateAlertRequest'] == null) {
            throw new runtime.RequiredError(
                'createRateAlertRequest',
                'Required parameter "createRateAlertRequest" was null or undefined when calling rateAlertsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/rate-alerts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRateAlertRequestToJSON(requestParameters['createRateAlertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateAlertFromJSON(jsonValue));
    }

    /**
     * Create a new rate alert for a hotel
     */
    async rateAlertsPost(requestParameters: RateAlertsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateAlert> {
        const response = await this.rateAlertsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns distinct room type names for a hotel. Accepts either a Vervotech property ID (preferred, skips lookup) or a Google Places ID (resolved via PropertyContent). Returns an empty array if no matching hotel or room types are found.
     */
    async searchHotelRoomTypesGetRaw(requestParameters: SearchHotelRoomTypesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['vervotechPropertyId'] != null) {
            queryParameters['vervotech_property_id'] = requestParameters['vervotechPropertyId'];
        }

        if (requestParameters['placeId'] != null) {
            queryParameters['place_id'] = requestParameters['placeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/hotel_room_types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns distinct room type names for a hotel. Accepts either a Vervotech property ID (preferred, skips lookup) or a Google Places ID (resolved via PropertyContent). Returns an empty array if no matching hotel or room types are found.
     */
    async searchHotelRoomTypesGet(requestParameters: SearchHotelRoomTypesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.searchHotelRoomTypesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list hotels and their availability
     */
    async searchHotelsPostRaw(requestParameters: SearchHotelsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelSearchResponse>> {
        if (requestParameters['hotelSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'hotelSearchRequest',
                'Required parameter "hotelSearchRequest" was null or undefined when calling searchHotelsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/hotels`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HotelSearchRequestToJSON(requestParameters['hotelSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelSearchResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list hotels and their availability
     */
    async searchHotelsPost(requestParameters: SearchHotelsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelSearchResponse> {
        const response = await this.searchHotelsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record batch of user search interaction events (impressions, clicks, detail views)
     */
    async searchInteractionsPostRaw(requestParameters: SearchInteractionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchInteractionBatchResponse>> {
        if (requestParameters['searchInteractionBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'searchInteractionBatchRequest',
                'Required parameter "searchInteractionBatchRequest" was null or undefined when calling searchInteractionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/interactions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchInteractionBatchRequestToJSON(requestParameters['searchInteractionBatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchInteractionBatchResponseFromJSON(jsonValue));
    }

    /**
     * Record batch of user search interaction events (impressions, clicks, detail views)
     */
    async searchInteractionsPost(requestParameters: SearchInteractionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchInteractionBatchResponse> {
        const response = await this.searchInteractionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Compute which of the user\'s free-night credits (FNCs) cover each of the requested properties. Static-priced chains only (Hyatt category, Wyndham Go Free tier) — GON-5965 Phase 4a. Properties with no seeded award attributes are omitted from the response (the FE shows no badge). 
     */
    async v2HotelFreeNightMatchPostRaw(requestParameters: V2HotelFreeNightMatchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FreeNightMatchResponse>> {
        if (requestParameters['freeNightMatchRequest'] == null) {
            throw new runtime.RequiredError(
                'freeNightMatchRequest',
                'Required parameter "freeNightMatchRequest" was null or undefined when calling v2HotelFreeNightMatchPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/hotel/free_night_match`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FreeNightMatchRequestToJSON(requestParameters['freeNightMatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FreeNightMatchResponseFromJSON(jsonValue));
    }

    /**
     * Compute which of the user\'s free-night credits (FNCs) cover each of the requested properties. Static-priced chains only (Hyatt category, Wyndham Go Free tier) — GON-5965 Phase 4a. Properties with no seeded award attributes are omitted from the response (the FE shows no badge). 
     */
    async v2HotelFreeNightMatchPost(requestParameters: V2HotelFreeNightMatchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FreeNightMatchResponse> {
        const response = await this.v2HotelFreeNightMatchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Book a room at a particular rate
     */
    async v2HotelHotelIdBookPostRaw(requestParameters: V2HotelHotelIdBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelBookingResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v2HotelHotelIdBookPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/hotel/{hotel_id}/book`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookingRequestToJSON(requestParameters['bookingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelBookingResponseFromJSON(jsonValue));
    }

    /**
     * Book a room at a particular rate
     */
    async v2HotelHotelIdBookPost(requestParameters: V2HotelHotelIdBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelBookingResponse> {
        const response = await this.v2HotelHotelIdBookPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate booking details before actual booking, returns warnings if any issues detected
     */
    async v2HotelHotelIdPreBookPostRaw(requestParameters: V2HotelHotelIdPreBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreBookResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v2HotelHotelIdPreBookPost().'
            );
        }

        if (requestParameters['preBookRequest'] == null) {
            throw new runtime.RequiredError(
                'preBookRequest',
                'Required parameter "preBookRequest" was null or undefined when calling v2HotelHotelIdPreBookPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/hotel/{hotel_id}/pre-book`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreBookRequestToJSON(requestParameters['preBookRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreBookResponseFromJSON(jsonValue));
    }

    /**
     * Validate booking details before actual booking, returns warnings if any issues detected
     */
    async v2HotelHotelIdPreBookPost(requestParameters: V2HotelHotelIdPreBookPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreBookResponse> {
        const response = await this.v2HotelHotelIdPreBookPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get reviews for a property
     */
    async v2HotelHotelIdReviewsGetRaw(requestParameters: V2HotelHotelIdReviewsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelReviewV2>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v2HotelHotelIdReviewsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/hotel/{hotel_id}/reviews`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelReviewV2FromJSON(jsonValue));
    }

    /**
     * Get reviews for a property
     */
    async v2HotelHotelIdReviewsGet(requestParameters: V2HotelHotelIdReviewsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelReviewV2> {
        const response = await this.v2HotelHotelIdReviewsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a rate\'s refundable status and cancel-offset days via the lookup table with a get_terms fallback
     */
    async v2HotelRateRefundablePostRaw(requestParameters: V2HotelRateRefundablePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateRefundableResponseV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/hotel/rate_refundable`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RateRefundableRequestV2ToJSON(requestParameters['rateRefundableRequestV2']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateRefundableResponseV2FromJSON(jsonValue));
    }

    /**
     * Resolve a rate\'s refundable status and cancel-offset days via the lookup table with a get_terms fallback
     */
    async v2HotelRateRefundablePost(requestParameters: V2HotelRateRefundablePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateRefundableResponseV2> {
        const response = await this.v2HotelRateRefundablePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate a rate before a booking is made with it
     */
    async v2HotelRateValidationPostRaw(requestParameters: V2HotelRateValidationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateValidationResponseV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/hotel/rate_validation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RateValidationRequestV2ToJSON(requestParameters['rateValidationRequestV2']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateValidationResponseV2FromJSON(jsonValue));
    }

    /**
     * Validate a rate before a booking is made with it
     */
    async v2HotelRateValidationPost(requestParameters: V2HotelRateValidationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateValidationResponseV2> {
        const response = await this.v2HotelRateValidationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get additional rates
     */
    async v3AdditionalRatesHotelIdGetRaw(requestParameters: V3AdditionalRatesHotelIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdditionalRateResponseV3>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v3AdditionalRatesHotelIdGet().'
            );
        }

        if (requestParameters['checkin'] == null) {
            throw new runtime.RequiredError(
                'checkin',
                'Required parameter "checkin" was null or undefined when calling v3AdditionalRatesHotelIdGet().'
            );
        }

        if (requestParameters['checkout'] == null) {
            throw new runtime.RequiredError(
                'checkout',
                'Required parameter "checkout" was null or undefined when calling v3AdditionalRatesHotelIdGet().'
            );
        }

        if (requestParameters['occupancy'] == null) {
            throw new runtime.RequiredError(
                'occupancy',
                'Required parameter "occupancy" was null or undefined when calling v3AdditionalRatesHotelIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkin'] != null) {
            queryParameters['checkin'] = (requestParameters['checkin'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkout'] != null) {
            queryParameters['checkout'] = (requestParameters['checkout'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkinStr'] != null) {
            queryParameters['checkin_str'] = requestParameters['checkinStr'];
        }

        if (requestParameters['checkoutStr'] != null) {
            queryParameters['checkout_str'] = requestParameters['checkoutStr'];
        }

        if (requestParameters['occupancy'] != null) {
            queryParameters['occupancy'] = requestParameters['occupancy'];
        }

        if (requestParameters['loyaltyAccountId'] != null) {
            queryParameters['loyalty_account_id'] = requestParameters['loyaltyAccountId'];
        }

        if (requestParameters['rateSources'] != null) {
            queryParameters['rate_sources'] = requestParameters['rateSources'];
        }

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        if (requestParameters['scrapeRequestType'] != null) {
            queryParameters['scrape_request_type'] = requestParameters['scrapeRequestType'];
        }

        if (requestParameters['directRatesTimeout'] != null) {
            queryParameters['direct_rates_timeout'] = requestParameters['directRatesTimeout'];
        }

        if (requestParameters['supportsGondolaCashDirectRates'] != null) {
            queryParameters['supports_gondola_cash_direct_rates'] = requestParameters['supportsGondolaCashDirectRates'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/additional_rates/{hotel_id}`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdditionalRateResponseV3FromJSON(jsonValue));
    }

    /**
     * Get additional rates
     */
    async v3AdditionalRatesHotelIdGet(requestParameters: V3AdditionalRatesHotelIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdditionalRateResponseV3> {
        const response = await this.v3AdditionalRatesHotelIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Server-sent-events stream of additional hotel rates. Replaces client polling: instead of re-fetching `/v3/additional_rates/{hotel_id}` every ~1s, the server pushes per-source events as Travelport / Direct / LiteAPI dispatches complete. Emits `session_start` once with the set of expected sources, one `rates` event per source completion, then a terminal `complete` (with the same payload shape as the polling endpoint\'s `AdditionalRateResponseV3`) or `error` event. 
     */
    async v3AdditionalRatesHotelIdStreamGetRaw(requestParameters: V3AdditionalRatesHotelIdStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v3AdditionalRatesHotelIdStreamGet().'
            );
        }

        if (requestParameters['checkin'] == null) {
            throw new runtime.RequiredError(
                'checkin',
                'Required parameter "checkin" was null or undefined when calling v3AdditionalRatesHotelIdStreamGet().'
            );
        }

        if (requestParameters['checkout'] == null) {
            throw new runtime.RequiredError(
                'checkout',
                'Required parameter "checkout" was null or undefined when calling v3AdditionalRatesHotelIdStreamGet().'
            );
        }

        if (requestParameters['occupancy'] == null) {
            throw new runtime.RequiredError(
                'occupancy',
                'Required parameter "occupancy" was null or undefined when calling v3AdditionalRatesHotelIdStreamGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkin'] != null) {
            queryParameters['checkin'] = (requestParameters['checkin'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkout'] != null) {
            queryParameters['checkout'] = (requestParameters['checkout'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkinStr'] != null) {
            queryParameters['checkin_str'] = requestParameters['checkinStr'];
        }

        if (requestParameters['checkoutStr'] != null) {
            queryParameters['checkout_str'] = requestParameters['checkoutStr'];
        }

        if (requestParameters['occupancy'] != null) {
            queryParameters['occupancy'] = requestParameters['occupancy'];
        }

        if (requestParameters['loyaltyAccountId'] != null) {
            queryParameters['loyalty_account_id'] = requestParameters['loyaltyAccountId'];
        }

        if (requestParameters['rateSources'] != null) {
            queryParameters['rate_sources'] = requestParameters['rateSources'];
        }

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        if (requestParameters['scrapeRequestType'] != null) {
            queryParameters['scrape_request_type'] = requestParameters['scrapeRequestType'];
        }

        if (requestParameters['directRatesTimeout'] != null) {
            queryParameters['direct_rates_timeout'] = requestParameters['directRatesTimeout'];
        }

        if (requestParameters['supportsGondolaCashDirectRates'] != null) {
            queryParameters['supports_gondola_cash_direct_rates'] = requestParameters['supportsGondolaCashDirectRates'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/additional_rates/{hotel_id}/stream`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Server-sent-events stream of additional hotel rates. Replaces client polling: instead of re-fetching `/v3/additional_rates/{hotel_id}` every ~1s, the server pushes per-source events as Travelport / Direct / LiteAPI dispatches complete. Emits `session_start` once with the set of expected sources, one `rates` event per source completion, then a terminal `complete` (with the same payload shape as the polling endpoint\'s `AdditionalRateResponseV3`) or `error` event. 
     */
    async v3AdditionalRatesHotelIdStreamGet(requestParameters: V3AdditionalRatesHotelIdStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.v3AdditionalRatesHotelIdStreamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns rich stored property content without fetching rates or invoking hotel suppliers.
     */
    async v3HotelHotelIdContentGetRaw(requestParameters: V3HotelHotelIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelPropertyContentResponse>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v3HotelHotelIdContentGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/hotel/{hotel_id}/content`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelPropertyContentResponseFromJSON(jsonValue));
    }

    /**
     * Returns rich stored property content without fetching rates or invoking hotel suppliers.
     */
    async v3HotelHotelIdContentGet(requestParameters: V3HotelHotelIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelPropertyContentResponse> {
        const response = await this.v3HotelHotelIdContentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details for a hotel.
     */
    async v3HotelHotelIdDetailsGetRaw(requestParameters: V3HotelHotelIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HotelDetailsResponseV3>> {
        if (requestParameters['hotelId'] == null) {
            throw new runtime.RequiredError(
                'hotelId',
                'Required parameter "hotelId" was null or undefined when calling v3HotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['checkin'] == null) {
            throw new runtime.RequiredError(
                'checkin',
                'Required parameter "checkin" was null or undefined when calling v3HotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['checkout'] == null) {
            throw new runtime.RequiredError(
                'checkout',
                'Required parameter "checkout" was null or undefined when calling v3HotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['occupancy'] == null) {
            throw new runtime.RequiredError(
                'occupancy',
                'Required parameter "occupancy" was null or undefined when calling v3HotelHotelIdDetailsGet().'
            );
        }

        if (requestParameters['userEnvironment'] == null) {
            throw new runtime.RequiredError(
                'userEnvironment',
                'Required parameter "userEnvironment" was null or undefined when calling v3HotelHotelIdDetailsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['checkin'] != null) {
            queryParameters['checkin'] = (requestParameters['checkin'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkout'] != null) {
            queryParameters['checkout'] = (requestParameters['checkout'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['checkinStr'] != null) {
            queryParameters['checkin_str'] = requestParameters['checkinStr'];
        }

        if (requestParameters['checkoutStr'] != null) {
            queryParameters['checkout_str'] = requestParameters['checkoutStr'];
        }

        if (requestParameters['occupancy'] != null) {
            queryParameters['occupancy'] = requestParameters['occupancy'];
        }

        if (requestParameters['loyaltyAccountId'] != null) {
            queryParameters['loyalty_account_id'] = requestParameters['loyaltyAccountId'];
        }

        if (requestParameters['userEnvironment'] != null) {
            queryParameters['user_environment'] = requestParameters['userEnvironment'];
        }

        if (requestParameters['rateSources'] != null) {
            queryParameters['rate_sources'] = requestParameters['rateSources'];
        }

        if (requestParameters['test'] != null) {
            queryParameters['test'] = requestParameters['test'];
        }

        if (requestParameters['scrapeRequestType'] != null) {
            queryParameters['scrape_request_type'] = requestParameters['scrapeRequestType'];
        }

        if (requestParameters['directRatesTimeout'] != null) {
            queryParameters['direct_rates_timeout'] = requestParameters['directRatesTimeout'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/hotel/{hotel_id}/details`;
        urlPath = urlPath.replace(`{${"hotel_id"}}`, encodeURIComponent(String(requestParameters['hotelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HotelDetailsResponseV3FromJSON(jsonValue));
    }

    /**
     * Get details for a hotel.
     */
    async v3HotelHotelIdDetailsGet(requestParameters: V3HotelHotelIdDetailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HotelDetailsResponseV3> {
        const response = await this.v3HotelHotelIdDetailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Predicts whether now is a good time to book based on price trends, percentile data, check-in urgency, and price volatility. 
     */
    async v3PricePredictPostRaw(requestParameters: V3PricePredictPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PricePredictionResult>> {
        if (requestParameters['pricePredictionRequest'] == null) {
            throw new runtime.RequiredError(
                'pricePredictionRequest',
                'Required parameter "pricePredictionRequest" was null or undefined when calling v3PricePredictPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/price/predict`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PricePredictionRequestToJSON(requestParameters['pricePredictionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PricePredictionResultFromJSON(jsonValue));
    }

    /**
     * Predicts whether now is a good time to book based on price trends, percentile data, check-in urgency, and price volatility. 
     */
    async v3PricePredictPost(requestParameters: V3PricePredictPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PricePredictionResult> {
        const response = await this.v3PricePredictPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const V3AdditionalRatesHotelIdGetRateSourcesEnum = {
    Direct: 'direct',
    Travelport: 'travelport',
    Liteapi: 'liteapi'
} as const;
export type V3AdditionalRatesHotelIdGetRateSourcesEnum = typeof V3AdditionalRatesHotelIdGetRateSourcesEnum[keyof typeof V3AdditionalRatesHotelIdGetRateSourcesEnum];
/**
 * @export
 */
export const V3AdditionalRatesHotelIdGetScrapeRequestTypeEnum = {
    Live: 'LIVE',
    Background: 'BACKGROUND'
} as const;
export type V3AdditionalRatesHotelIdGetScrapeRequestTypeEnum = typeof V3AdditionalRatesHotelIdGetScrapeRequestTypeEnum[keyof typeof V3AdditionalRatesHotelIdGetScrapeRequestTypeEnum];
/**
 * @export
 */
export const V3AdditionalRatesHotelIdStreamGetRateSourcesEnum = {
    Direct: 'direct',
    Travelport: 'travelport',
    Liteapi: 'liteapi'
} as const;
export type V3AdditionalRatesHotelIdStreamGetRateSourcesEnum = typeof V3AdditionalRatesHotelIdStreamGetRateSourcesEnum[keyof typeof V3AdditionalRatesHotelIdStreamGetRateSourcesEnum];
/**
 * @export
 */
export const V3AdditionalRatesHotelIdStreamGetScrapeRequestTypeEnum = {
    Live: 'LIVE',
    Background: 'BACKGROUND'
} as const;
export type V3AdditionalRatesHotelIdStreamGetScrapeRequestTypeEnum = typeof V3AdditionalRatesHotelIdStreamGetScrapeRequestTypeEnum[keyof typeof V3AdditionalRatesHotelIdStreamGetScrapeRequestTypeEnum];
/**
 * @export
 */
export const V3HotelHotelIdDetailsGetScrapeRequestTypeEnum = {
    Live: 'LIVE',
    Background: 'BACKGROUND'
} as const;
export type V3HotelHotelIdDetailsGetScrapeRequestTypeEnum = typeof V3HotelHotelIdDetailsGetScrapeRequestTypeEnum[keyof typeof V3HotelHotelIdDetailsGetScrapeRequestTypeEnum];
